// extracted by mini-css-extract-plugin
export var image = "styles-module__image___jjzkn";
export var title = "styles-module__title___Up1P9";
export var container = "styles-module__container___K40MR";